import { MainContents } from '@/components/MainContents';

type Props = {
  errorMessage?: string;
};

export function PdfImportFailedStatus({ errorMessage }: Props) {
  return (
    <MainContents>
      <div className="flex min-h-screen flex-col bg-white p-6">
        <div className="mb-4">
          <h1 className="text-xl leading-[1.4] font-bold text-main">処理に失敗しました</h1>
          <p className="mt-2 text-sm text-sub">
            {errorMessage ?? 'PDFの処理中にエラーが発生しました。もう一度お試しください。'}
          </p>
        </div>
      </div>
    </MainContents>
  );
}
